/* Stablemint's card checkout runs in a frame on this page and asks to be
   closed with a `postMessage("close")` from its providers host. Only those two
   origins are listened to — any other frame or window could otherwise close
   the checkout (StablemintCardDepositModal in the whitelabel). */
export const STABLEMINT_PROVIDER_ORIGINS = ["https://providers.stablemint.net", "https://providers.stablemint.io"];

export const isStablemintCloseMessage = (origin: string, data: unknown) =>
  STABLEMINT_PROVIDER_ORIGINS.includes(origin) && data === "close";
